import Vue from 'vue';
import axios from 'axios';
import RirLib from './RirLib';
import main from '../main';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  config => {
    config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`;
    return config;
  },
  error =>
    // Do something with request error
    Promise.reject(error)

);

// Add a response interceptor
_axios.interceptors.response.use(
  response =>
    // Do something with response data
    response,
  error => {
    const { data } = error.response;
    // Do something with response error
    if (data.message) {
      main.$rir.notification.send({
        title: data.message || 'Ошибка!',
        seconds: 5,
        hiddenClose: false,
        iconOptions: {
          icon: 'warning',
          fill: 'fargo'
        }
      });
      /* main.$root.$notification({
        type: 'error',
        text: data.message
      }) */
    }
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
